const ZWSP = '\u200B';

const ZWSP_RE = /\u200B/g;

/** Strip zero-width spaces so diff/render pipelines don't treat them as user content. */
export const stripZeroWidthSpaces = (value: string): string => value.replace(ZWSP_RE, '');

/** `data-index` as a number, or null when absent or unparseable. */
export const parseIndexAttr = (value: string | undefined | null): number | null => {
  const parsed = value == null ? NaN : Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

/** The visible citation chip. Stored elements are empty, so every renderer draws this itself. */
export const formatCitationLabel = (index: number | null): string => `[${index ?? '?'}]`;
